import { MY_FOODS_PATH } from '@/constants/paths';
import type { MyFoodsPageQueryParams } from '@/components/screens/MyFoodsPage/MyFoodsPage.model';

export const getMyFoodsPageUrl = (
  filters?: Partial<MyFoodsPageQueryParams>,
) => {
  if (!filters) return MY_FOODS_PATH;

  const filterSearchParams = new URLSearchParams(
    filters as Record<string, string>,
  );

  return `${MY_FOODS_PATH}?${filterSearchParams}`;
};
